import { createRoute } from "@tanstack/solid-router";
// FLAGS: the entire page is gated by feature (active org).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { Coins } from "@fleet/icons";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer, PageHeader } from "@fleet/ui";
import { FinanceRates } from "@/features/finance/components/finance-rates";

function FinanceRatesPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="3xl">
      <PageHeader title={t(msg`Exchange rates`)} backTo="/finance" icon={Coins} />
      <div class="mt-4">
        <FinanceRates />
      </div>
    </PageContainer>
  );
}

export const financeRatesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/finance/rates",
  component: withFeatureGate("billing.core", FinanceRatesPage),
});
